module.exports = __webpack_public_path__ + "img/home.e51e84ee.jpg";